import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowLeft, MessageCircle, Mail, Clock } from "lucide-react";
import RbiBadge from "@/components/RbiBadge";
import { CONTACT } from "@/constants/testIds";

const WHATSAPP_NUMBER = "919497012345"; // +91 94970 12345 (Flo Payments support)
const WHATSAPP_DISPLAY = "+91 94970 12345";

export default function Contact() {
  const navigate = useNavigate();
  const waLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi Flo Payments, I need help with my collection account."
  )}`;

  return (
    <div className="min-h-screen">
      <header className="border-b bg-white">
        <div className="max-w-3xl mx-auto flex items-center gap-2 p-4 md:p-6">
          <Button variant="ghost" size="sm" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-4 w-4 mr-2" /> Back
          </Button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto p-6 md:p-10">
        <RbiBadge className="mb-8" />
        <h1 className="font-display text-3xl md:text-4xl font-extrabold text-foreground tracking-tight mb-3">
          Need help with a payment?
        </h1>
        <p className="text-muted-foreground text-base mb-10 max-w-xl">
          {"We're a small team based in India. WhatsApp is the fastest way to reach us — usually within 30 minutes during working hours."}
        </p>

        <Card className="mb-6">
          <CardContent className="p-8">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <div className="flex items-center gap-4">
                <div className="h-14 w-14 rounded-2xl bg-[#25D366]/10 grid place-items-center">
                  <MessageCircle className="h-7 w-7 text-[#25D366]" />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-wider text-muted-foreground font-medium">WhatsApp</p>
                  <p className="font-display text-2xl font-bold text-foreground sf-mono">{WHATSAPP_DISPLAY}</p>
                </div>
              </div>
              <a href={waLink} target="_blank" rel="noopener noreferrer" data-testid={CONTACT.waLink}>
                <Button className="h-12 px-6 bg-[#25D366] hover:bg-[#1EBE5D] text-white font-semibold rounded-lg">
                  <MessageCircle className="h-4 w-4 mr-2" /> Message us on WhatsApp
                </Button>
              </a>
            </div>
          </CardContent>
        </Card>

        <div className="grid md:grid-cols-2 gap-6">
          <Card>
            <CardContent className="p-6 flex gap-4 items-start">
              <div className="h-10 w-10 rounded-lg bg-primary/10 grid place-items-center">
                <Mail className="h-5 w-5 text-primary" />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wider text-muted-foreground font-medium">Email</p>
                <p className="font-medium">support@useflopayments.com</p>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-6 flex gap-4 items-start">
              <div className="h-10 w-10 rounded-lg bg-primary/10 grid place-items-center">
                <Clock className="h-5 w-5 text-primary" />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wider text-muted-foreground font-medium">Hours</p>
                <p className="font-medium">Mon – Fri &middot; 10:00 AM – 6:00 PM IST</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
}
